<script>
import { get } from '@rails/request.js';

export default {
  name: 'TimetableMixin',
  data() {
    return {
      slotDurationTimes: {
        collapsed: '00:30:00',
        expanded: '00:15:00'
      },
      slotDurationIcons: {
        collapse: 'bi-arrows-collapse-vertical',
        expand: 'bi-arrows-expand-vertical'
      }
    }
  },
  mounted() {
    document.querySelectorAll(".fc-toolbar button").forEach(e => {
      e.classList.remove("btn-primary")
      e.classList.add("btn-outline-secondary")
    });
  },
  methods: {
    createButtonText: function(text) {
      const buttonText = document.createElement('span');
      buttonText.textContent = text;
      buttonText.className = "ps-1 d-none d-md-inline";
      return buttonText;
    },
    getEventByIdAndSource(id, sourceId) {
      return this.$refs.calendar.getApi().getEvents().find(event =>
        event.id == id && event.source.id == sourceId
      );
    },
    isDateOnSameDay: function(dateA, dateB) {
      return dateA.getFullYear() === dateB.getFullYear() &&
             dateA.getMonth() === dateB.getMonth() &&
             dateA.getDate() === dateB.getDate()
    },
    onDateChanged: function(dateInfo) {
      dateInfo.end.setSeconds(dateInfo.end.getSeconds() - 1)
      const calendarApi = this.$refs.calendar.getApi()

      var startEventDate = new Date(this.eventStartDate)
      if (this.isDateOnSameDay(dateInfo.start, startEventDate)) {
        const slotMinTime = `${('0'+Math.max(startEventDate.getHours()-1, 0)).slice(-2)}:${('0'+startEventDate.getMinutes()).slice(-2)}:${('0'+startEventDate.getSeconds()).slice(-2)}`
        calendarApi.setOption('slotMinTime', slotMinTime)
      } else {
        calendarApi.setOption('slotMinTime', "00:00:00")
      }

      var endEventDate = new Date(this.eventEndDate)
      if (this.isDateOnSameDay(dateInfo.end, endEventDate)) {
        const slotMaxTime = `${('0'+Math.min(endEventDate.getHours()+1, 24)).slice(-2)}:${('0'+endEventDate.getMinutes()).slice(-2)}:${('0'+endEventDate.getSeconds()).slice(-2)}`
        calendarApi.setOption('slotMaxTime', slotMaxTime)
      } else {
        calendarApi.setOption('slotMaxTime', "24:00:00")
      }
    },
    toggleSlotDuration: function() {
      const calendarApi = this.$refs.calendar.getApi()
      const button = document.querySelector(".fc-toggleSlotDuration-button > span")
      let newSlotDuration;

      if (calendarApi.getOption('slotDuration') == this.slotDurationTimes.collapsed) {
        button.classList.add(this.slotDurationIcons.collapse)
        button.classList.remove(this.slotDurationIcons.expand)
        newSlotDuration = this.slotDurationTimes.expanded
      } else {
        button.classList.add(this.slotDurationIcons.expand)
        button.classList.remove(this.slotDurationIcons.collapse)
        newSlotDuration = this.slotDurationTimes.collapsed
      }

      calendarApi.setOption('slotDuration', newSlotDuration);
    },
    onClick: async function(eventClickInfo) {
      eventClickInfo.jsEvent.preventDefault();
    },
    refreshShiftsOfVolunteer: async function(volunteerId) {
      const calendarApi = this.$refs.calendar.getApi()
      const response = await get(this.shiftsUrl, { query: {
        "start": calendarApi.view.currentStart.toISOString(),
        "end": calendarApi.view.currentEnd.toISOString(),
        "volunteer_id": volunteerId,
      }})
      if (!response.ok) {
        return
      }

      const shiftEventSource = calendarApi.getEventSourceById("shifts")
      const content = await response.json
      for (const shift of content) {
        this.getEventByIdAndSource(shift.id, 'shifts')?.remove()
        calendarApi.addEvent(shift, shiftEventSource)
      }
    },
  }
}
</script>
